import { createRef } from 'react'
import { FlatList } from 'react-native'

const recommendationsFlatListRef = createRef<FlatList>()

const useRecommendationsFlatlistRef = () => {
  return recommendationsFlatListRef
}

export default useRecommendationsFlatlistRef
